import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// Components
import { Button } from '../../../../components/Button';

const ControlBarCont = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 2rem;
    margin-top: -2rem;
    justify-content: space-between;
    position: relative;
    padding-bottom: 0.75rem;
    padding-top: 0.75rem;
    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: -25%;
        right: -25%;
        height: 1px;
        background: #8080803b;
    }
`;

const ActionButtons = styled.div`
    display: flex;
    flex-direction: row;
`;

export const ReportControlBar = ({ onBack, children, ...props }) => {
    return (
        <ControlBarCont>
            {onBack ? (
                <Button onClick={onBack} hasIcon iconPosition={'left'} icon={`chevron_left`}>
                    Back
                </Button>
            ) : null}
            <ActionButtons>{children}</ActionButtons>
        </ControlBarCont>
    );
};

ReportControlBar.propTypes = {
    children: PropTypes.node,
    onBack: PropTypes.func
};

ReportControlBar.defaultProps = {};
